<div class="prefixed" >
    <div class="form-input">
        <input type="text" #key class="form-control" 
         [(ngModel)]="search"
        (keyup.enter)="sendInput($event)" (input)="getLength($event)" [placeholder]="placeholder">
        <fa-icon class="prefix " [icon]="icons.search" (click)="iconClick(key.value)"></fa-icon>             
        <span (click)="clearInput()" class="suffix" *ngIf="valueLength > 3">
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="18" height="18" rx="9" fill="#FB7185"/>
                <path d="M13 6L6 13M6 6L13 13" stroke="white" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
        </span>             
    </div>
</div>